import { defineStore } from 'pinia';

export const useDeviceVerifierStore = defineStore('deviceVerifier', {
  state: () => ({
    uuid: '',
    isVerified: false,
    showVerificationModal: false,
    errorMessage: '',
  }),
  actions: {
    getErrorMessage() {
      return this.errorMessage;
    },
    getIsVerified() {
      return this.isVerified;
    },
    getUuid() {
      return this.uuid;
    },
    setErrorMessage(message) {
      this.errorMessage = message;
    },
    setIsVerified(value) {
      this.isVerified = value;
    },
    setUuid(value) {
      this.uuid = value;
    },
    resetVerifier() {
      this.uuid = '';
      this.isVerified = false;
      this.showVerificationModal = false;
      this.errorMessage = '';
    },
    openPosVerifierModal() {
      this.showVerificationModal = true;
    },
    closePosVerifierModal() {
      this.showVerificationModal = false;
    },
  },
  persist: true,
});
